// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"710":"e4262890c2cb0d3d","888":"c4e1fb209439d478"}[chunkId] + ".css";
};